/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-27 16:18:59
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-27 16:50:45
 */

export default {
  path: 'mission_center',
  component: () => import(/* webpackChunkName: "common-list" */ '@/pages/mis/MissionList'),
  meta: {title:'任务中心',cate:'查询中心'},
	children: [
		{
			path: ':view',
			name: 'mission_center_view',
			component: () => import(/* webpackChunkName: "customer-view" */ '@/pages/mis/CreateEdit'),
			meta: {title:'任务详情'},
		}
	]
}